import React, { Fragment, useRef, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";

const Contact = () => {
  const sref = useRef(null);
  useEffect(() => {
    scrollToRef(sref);
  }, []);

  const scrollToRef = (ref) => ref.current.scrollIntoView();
  return (
    <Fragment>
      <Header name="Contact Us" />
      <section
        className="breadcrumb_area breadcrumb2 bgimage biz_overlay"
        ref={sref}
      >
        <div className="bg_image_holder">
          <img src="img/breadbg.jpg" alt="contact" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Contact Us</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Contact Us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact--four">
        <div className="list-inline-wrapper p-top-80 p-bottom-50">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ul className="icon-list--three d-flex list--inline">
                  <li className="d-flex align-items-center">
                    <div className="icon">
                      <span>
                        <i className="la la-headphones"></i>
                      </span>
                    </div>
                    <div className="contents">
                      <h6>+91 8912731634</h6>
                    </div>
                  </li>

                  <li className="d-flex align-items-center">
                    <div className="icon">
                      <span>
                        <i className="la la-envelope"></i>
                      </span>
                    </div>
                    <div className="contents">
                      <h6>info@vbtpl.com</h6>
                    </div>
                  </li>

                  <li className="d-flex align-items-center">
                    <div className="icon">
                      <span>
                        <i className="la la-map-marker"></i>
                      </span>
                    </div>
                    <div className="contents">
                      <h6>Siripuram, Visakapatnam</h6>
                      <span className="sub-text">
                        Padmavathi Towers, Balaji Nagar
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container p-top-100 p-bottom-110">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-wrapper">
                <div className="m-bottom-10">
                  <div className="divider divider-simple text-left">
                    <h3>Let&#39;s Get In Touch</h3>
                  </div>
                </div>
                <p className="m-bottom-30">
                  Thank you for taking the time to visit our website. Please
                  feel free to drop your details below in case you have any
                  queries or would like to find out more about us. You can also
                  share your experience as a visitor. We will take your
                  suggestions into account so as to continuously improve our
                  services
                </p>
                <form>
                  <input
                    type="text"
                    className="form-control form-outline mb-4"
                    placeholder="Name"
                    required
                  />
                  <input
                    type="email"
                    className="form-control form-outline mb-4"
                    placeholder="Email"
                    required
                  />
                  <textarea
                    className="form-control form-outline mb-4"
                    placeholder="Messages"
                    required
                  ></textarea>
                  <button className="btn btn-primary" type="submit">
                    Submit Now
                  </button>
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="m-bottom-25">
                <div className="divider divider-simple text-left">
                  <h3>Google Map</h3>
                </div>
              </div>
              <div className="gmap2">
                <div className="map" id="map3">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15172.97662810642!2d83.5457441!3d18.0602484!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa9860fdad6754e91!2sVijaynagar%20Bio%20Tech!5e0!3m2!1sen!2sin!4v1666714686074!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    loading="lazy"
                    title="mapsvijayanagar"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default Contact;
